import { ProcessService } from './services/process.service';
import { CommonModule } from '@angular/common';
import { WidgetService } from '../main/widgets/widget.service';
import { UserManagementService } from './apis/UserMgtAPI/index';
import { DataFieldService } from './services/data-field.service';
import { JsonService } from './services/json.service';
import { NavigationService } from './services/navigation.service';
import { NoteService } from './services/note.service';
import { ProcessTypeService } from './services/process-type.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SubjectLinkService } from './services/subject-link.service';
import { SubjectNoteService } from './services/subject-note.service';
import { TaskNoteService } from './services/task-note.service';
import {
  DueDateTypeService,
  TaskStatusService,
} from './services/task-type.service';
import { TemplateService } from './services/template.service';
import { UserMgtService } from './services/user-management.service';
import { HasPrivDirective, ShowAuthedDirective } from './show-authed.directive';
import { MessageModule } from './services/messages/message.module';
import { TaskService } from './services/task.service';
import { UserService } from './services/user.service';
import { RulesEngineService } from './services/rules-engine.service';
import { FileService } from './services/file.service';
import { StatisticsService } from './services/statistics.service';
import { UserTemplateService } from './services/user-template.service';
import { StatusService } from './services/status.service';
import { StateService } from './services/state.service';
import { AutoLogoutService } from './services/auto-logout.service';
import { SystemSettingsService } from './services/system-settings.service';
import { FeedbackService } from './services/feedback.service';
import { UserSettingService } from './services/user-setting.service';
import { PrintService } from './services/print.service';
import { PrintHtmlService } from './services/print-html.service';
import { SubjectLayoutService } from './services/subject-layout.service';
import { SubjectPrintService } from './services/subject-print.service';
import { UserSubjectHistoryService } from './services/user-subject-history.service';
import { MarkerService } from './services/marker.service';
import { ReferralSourceService } from './services/referral-source.service';
import { UserSecurityService } from './services/user-security.service';
import { EntityDashboardService } from './services/entity-dashboard.service';
import { UserComponentsModule } from 'app/main/content/users/user-components.module';
import { AssessmentCategoryService } from './services/assessment-category.service';
import { AssessmentTemplateService } from './services/assessment-template.service';
import { AssessmentTypeService } from './services/assessment-type.service';
import { ReviewService } from './services/review.service';
import { HydrateSubjectService } from './services/hydrate-subject.service';
import { WorkflowService } from './services/workflow.service';
import { WorkflowTriggerService } from './services/workflow-trigger.service';
import { WorkflowActionService } from './services/workflow-action.service';
import { ImportService } from './services/import.service';
import { SubjectSettingsModule } from './subject-settings.module';
import { LookupCategoryService } from './services/lookup-category.service';
import { OnlineReportSettingService } from './services/online-report-setting.service';
import { MonitoringModule } from './services/monitoring/monitoring.module';
import { NoteTypeService } from './services/note-type.service';
import { MatchTypesServices } from './services/match-types.service';
import { ReportingModule } from './services/reporting/reporting.module';
import { SubjectVisualizerService } from './services/subject-visualizer.service';
import { DateModule } from 'app/main/content/misc/date.module';
import { HyperLawService } from './services/hyper-law.service';
import { RetentionService } from './services/retention.service';

@NgModule({
  declarations: [ShowAuthedDirective, HasPrivDirective],
  imports: [
    CommonModule,
    MessageModule,
    MonitoringModule,
    UserComponentsModule,
    SubjectSettingsModule,
    ReportingModule,
    DateModule,
  ],
  exports: [ShowAuthedDirective, HasPrivDirective],
  providers: [JsonService, WidgetService],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SubjectLinkService,
        NavigationService,
        UserMgtService,
        UserManagementService,
        DataFieldService,
        NoteService,
        LookupCategoryService,
        ProcessTypeService,
        ProcessService,
        TemplateService,
        SubjectNoteService,
        TaskNoteService,
        RetentionService,
        DueDateTypeService,
        TaskStatusService,
        RulesEngineService,
        FileService,
        UserService,
        TaskService,
        StateService,
        StatusService,
        StatisticsService,
        UserSettingService,
        UserTemplateService,
        AutoLogoutService,
        SystemSettingsService,
        FeedbackService,
        PrintService,
        PrintHtmlService,
        SubjectLayoutService,
        SubjectPrintService,
        UserSubjectHistoryService,
        MarkerService,
        OnlineReportSettingService,
        ReferralSourceService,
        AssessmentCategoryService,
        AssessmentTemplateService,
        AssessmentTypeService,
        UserSecurityService,
        EntityDashboardService,
        ReviewService,
        HydrateSubjectService,
        WorkflowService,
        WorkflowActionService,
        WorkflowTriggerService,
        ImportService,
        NoteTypeService,
        MatchTypesServices,
        SubjectVisualizerService,
        HyperLawService,
      ],
    };
  }
}
